import { Flexbox } from '@piconetworks/pkg-box'
import styles from './TitleBar.module.scss'

const TitleBar = ({ children = null }) => {
    return <Flexbox.Container alignItems="center" className={styles.titlebar}>{children}</Flexbox.Container>
}

export default TitleBar
